import styled from "styled-components";
import { Overlay } from "@core-ui/components/overlay";

export const OverlayStyled = styled(Overlay)(({ theme }) => ({
    background: `${theme.colors[theme.colorMode].text_inverse_Med_Emphasis} !important`,
    pointerEvents: "auto",
}));
